import { render, staticRenderFns } from "./OpenFieldStats.vue?vue&type=template&id=102d00aa&scoped=true"
import script from "./OpenFieldStats.vue?vue&type=script&lang=js"
export * from "./OpenFieldStats.vue?vue&type=script&lang=js"
import style0 from "./OpenFieldStats.vue?vue&type=style&index=0&id=102d00aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102d00aa",
  null
  
)

export default component.exports